export default __webpack_public_path__ + "static/media/betside_receipt.4e1290fc.jpg";